import { combineReducers } from 'redux'

import batteries from './entities/batteries'
import categories from './entities/categories'
import colors from './entities/colors'
import compartments from './entities/compartments'
import controls from './entities/controls'
import diameters from './entities/diameters'
import executions from './entities/executions'
import inventories from './entities/inventories'
import items from './entities/items'
import locations from './entities/locations'
import maintenances from './entities/maintenances'
import owners from './entities/owners'
import products from './entities/products'
import users from './entities/users'

export default combineReducers({
  batteries,
  categories,
  colors,
  compartments,
  controls,
  diameters,
  executions,
  inventories,
  items,
  locations,
  maintenances,
  owners,
  products,
  users
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities.js